import { Component, Input, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { CheckoutService } from 'src/app/checkout/services/checkout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionVariable } from '../../enum/session-variable';
import { MessageService } from 'primeng/api';
import { SharedSignalsService } from '../../services/shared-signals.service';

@Component({
    selector: 'taly-verify-payment',
    templateUrl: './verify-payment.component.html',
    styleUrls: ['./verify-payment.component.scss'],
    providers: [CheckoutService],
    standalone: false
})
export class VerifyPaymentComponent implements OnInit {

  transferSignal = inject(SharedSignalsService)

  @Input({ required: true }) paymentType: string;
  @Input({ required: true }) key: string;
  @Input() tap_id: string;
  @Input() orderid: string;
  @Input({ required: true }) status: string;
  resultIndicator: any;
  @Input() sessionVersion: string;
  @Input() checkoutVersion: string;
  interval: any;
  message: string = "Processing";
  isSuccess: boolean = false;

  constructor(private authService: AuthService, private checkoutService: CheckoutService, private toasterService: MessageService,
    private router: Router, private storageService: LocalStorageService, private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.resultIndicator = params['resultIndicator'];  // Extract resultIndicator from the query string
    });
    this.transferSignal.setFooter(false);
    this.transferSignal.setHeader(false);
    this.transferSignal.setDarkHeader(false)
    this.transferSignal.headerType.set(undefined);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.orderid = this.storageService.getItem(SessionVariable.ORDER_ID);
    if (this.paymentType == "knet") {
      this.startInterval();
    } else if (this.paymentType === 'mastercard') {
      this.getResultIndicator();
    } else {
      this.retrieveCharge()
    }
  }

  startInterval() {
    this.interval = setInterval(() => {
      this.retrieveCharge();
    }, 3000);
  }
  retrieveCharge() {
    this.authService.retrieveCharge(this.tap_id, this.paymentType).subscribe(resp => {
      if (resp?.status != 'INITIATED') {
        clearInterval(this.interval);
        const message = `${resp?.status} - Transaction ID ${resp?.paymentReference}`
        this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, message);
        // this.storageService.setItem(SessionVariable.PAYMENT_REFERENCE, resp?.paymentReference);
        this.storageService.setItem(SessionVariable.REDIRECTION_URL, resp?.redirectUrl);
        this.paymentStatus(resp);
      }
    }, err => {
      this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, err);
      this.checkoutService.showMessage('error', err)
    })
  }

  getResultIndicator() {
    this.checkoutService.resultIndicatorStatus({resultIndicator: this.resultIndicator}).subscribe(res => {
      if(res?.id){
        this.payByCard(res?.id)
      }else{
        this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, "Something was wrong while verifying card, please try again.");
        this.checkoutService.showMessage('error', "Something was wrong while verifying card, please try again.")
      }
    }, err => {
      this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, err);
      this.checkoutService.showMessage('error', err)
    })
  }

  paymentStatus(data: any) {
    if (this.paymentType == 'knet') {
      if (data?.status == 'SUCCESS') {
        this.navidateTo(data, true)
      } else {
        this.navidateTo(data, false)
      }
    } else {
      if (data?.status == 'VALID' && data?.object == 'verify_card') {
        this.status == 'success'
        if (this.orderid) {

          if (this.storageService.getItem(SessionVariable.AUTO_PAY)) {
            this.payByCard(data?.userCreditCardId)
          } else {
            setTimeout(() => {
              this.redirectToPaymentPage();
            }, 1500);
          }
        } else {
          setTimeout(() => {
            this.navidateTo(data, this.isSuccess);
          }, 1500);
        }

      } else if (data?.status == 'INVALID' && data?.object == 'verify_card') {
        this.message = data?.response?.message;
        this.isSuccess = false;
        this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, this.message);
        //this.router.navigate(['/secure-checkout/', this.orderid, 'payment', 'reject']);
        this.redirectToPaymentPage();

        this.toasterService.clear();
        this.toasterService.add({ severity: 'error', detail: "We are unable to add your card, please try again" });

      }
    }
  }

  redirectToPaymentPage() {
    this.router.navigate(['/secure-checkout/', this.orderid, 'payment-method']);
  }
  redirectToCheckoutPage
    (orderToken: string, isSuccess: boolean) {
    if (orderToken) {
      this.router.navigate(['/secure-checkout/', orderToken, 'payment', isSuccess ? 'success' : 'reject']);
    } else {
      this.router.navigate(['/consumer/billing']);
    }
  }

  navidateTo(data: any, status: boolean) {
    switch (data?.paymentType) {
      case 'DOWNPAYMENT':
        this.storageService.setItem(SessionVariable.REDIRECTION_URL, data?.redirectUrl);
        this.storageService.setItem(SessionVariable.ORDER_ID, data?.orderToken);
        this.redirectToCheckoutPage(data?.orderToken, status);
        break;
      case 'FULLPAYMENT':
      case 'INSTALLMENT':
        this.router.navigate(['/consumer/dashboard'], { queryParams: { st: status } });
        break;
      case 'BULK_INSTALLMENT':
        this.router.navigate(['/consumer/dashboard'], { queryParams: { st: status } });
        break;
      default:
        this.router.navigate(['/consumer/dashboard'], { queryParams: { st: status } });
        break;
    }

  }

  payByCard(userCreditCardId: number) {

    let requestBody: any = {
      orderToken: this.storageService.getItem(SessionVariable.ORDER_ID),
      paymentPlanId: this.storageService?.getItem(SessionVariable.PAYMENT_PLAN_ID),
      paymentMethod: 'CREDIT',
      paymentType: 'DOWNPAYMENT',
      creditCardId: userCreditCardId
    };

    this.authService.orderProcess(requestBody).subscribe(res => {
      this.storageService.setItem(SessionVariable.REDIRECTION_URL, res?.redirectUrl);
      this.storageService.setItem(SessionVariable.PAYMENT_REFERENCE, res?.paymentReference);
      if (res.orderStatus == 'CONFIRMED' || res.paymentStatus == 'CAPTURED') {
        this.router.navigate(['/secure-checkout/', this.orderid, 'payment', 'success']);
      }
      else {
        this.router.navigate(['/secure-checkout/', this.orderid, 'payment', 'reject']);
      }
      this.storageService.removeItem(SessionVariable.AUTO_PAY);
    }, (err) => {
      this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, err);
      this.router.navigate(['/secure-checkout/', this.orderid, 'payment', 'reject']);
      // this.checkoutService.showMessage('error', err);
      this.storageService.removeItem(SessionVariable.AUTO_PAY);
    });
  }
  ngOnDestroy() {
    this.transferSignal.setHeader(true);
    this.transferSignal.setDarkHeader(true)

  }

}
